export const FOREACH_CUSTOM_ATTRIBUTE_INDEX_AS_DEFAULT_VALUE = "index";
export const FOREACH_CUSTOM_ATTRIBUTE_AS_DEFAULT_VALUE = "item";